import React, { useEffect, useState } from 'react';
import ReactHelmet from 'react-helmet';

import { pageTitle } from '../../system-utils/events-manager';

export const DynamicPageTitle: React.FC = () => {
  // TODO: consider system error state when composing page title
  const [title, setTitle] = useState(pageTitle.getPageTitle());

  useEffect(() => {
    const subscription = pageTitle.subject.subscribe(value => {
      setTitle(pageTitle.getPageTitle());
    });
    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return (
    <>
      <ReactHelmet title={title} />
    </>
  );
};
